module.exports = __webpack_public_path__ + "static/media/feature.7186ccef.png";